




















import { Component, Prop, Vue } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import OfferItemWithoutImage from './OfferItemWithoutImage.vue';

@Component({
  components: {
    Typography,
    OfferItemWithoutImage
  }
})
export default class CompleteOfferWithImages extends Vue {
  @Prop() offers!: any;
}
